import styled from "styled-components/macro";

export default function FnrDividerLine({ title, style }) {
  return (
    <Wrapper style={style}>
      <Title>{title}</Title>
      <Line />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
`;
const Title = styled.div`
  color: #828c8d;
  text-transform: uppercase;
  font-size: 12px;
  padding-right: 12px;
  flex-grow: 0;
  flex-shrink: 0;
  font-weight: 400;
`;
const Line = styled.div`
  flex-grow: 1;
  height: 1px;
  background: #828c8d;
  opacity: 0.5;
`;
